module.exports = __webpack_public_path__ + "img/gi_puzzlekubus.e1dc989b.png";